import React from 'react';

import PropTypes from 'prop-types';

import * as Style from './style';

const VideoFrame = ({ src }) => <Style.Frame src={src} />;

VideoFrame.propTypes = {
	src: PropTypes.string.isRequired,
};

export default VideoFrame;
